import { createBrowserRouter } from "react-router-dom";
import Main from "../Layout/Main";
import About from "../pages/About/About";
import Blog from "../pages/Blog/Blog";
import Contact from "../pages/Contact/Contact";
import Home from "../pages/Home/Home";
import NotFound from "../pages/NotFound/NotFound";
import SinglePade3 from "../pages/Work/SinglePage/SinglePade3";
import SinglePage1 from "../pages/Work/SinglePage/SinglePage1";
import SinglePage2 from "../pages/Work/SinglePage/SinglePage2";
import SinglePage4 from "../pages/Work/SinglePage/SinglePage4";
import Work from "../pages/Work/Work";
import { Form } from "../shared/Form/Form";

export const router = createBrowserRouter([
    {
        path:'/',
        element:<Main></Main>,
        children:[
            {
                path:'/',
                element:<Home></Home>
            },
            {
                path:'/about',
                element:<About></About>
            },
            {
                path:'/my-work',
                element:<Work></Work>
            },
            {
                path:'/contact',
                element:<Contact></Contact>
            },
            {
                path:'/mobile-contact',
                element:<Form></Form>
            },
            {
                path:'/blog',
                element:<Blog></Blog>
            },
            {
                path:'/tree-pagla',
                element:<SinglePage1></SinglePage1>
            },
            {
                path:'/daily-life',
                element:<SinglePage2></SinglePage2>
            },
            {
                path:'/book-express',
                element:<SinglePade3></SinglePade3>
            },
            {
                path:'/iq-shake',
                element:<SinglePage4></SinglePage4>
            },
            {
                path:'*',
                element:<NotFound></NotFound>
            }
        ]
    }
])

export default router;